module.exports = __webpack_public_path__ + "img/transaction.60a38ed4.svg";